import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const Logout = () => {
  const navigate = useNavigate();
  const hasLoggedOut = useRef(false);

useEffect(() => {
  const logoutUser = async () => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;

    const token = sessionStorage.getItem("access_token");

    try {
      if (token) {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      }

      sessionStorage.clear();
      localStorage.removeItem("appSettings"); // clear saved logo/name

      // Reset favicon and title to defaults
const favicon = document.querySelector("link[rel~='icon']");
if (favicon) {
  favicon.setAttribute("href", "data:,"); // blank favicon
}

      document.title = "Powered by KloudData";
      toast.success("Logout Successful!", {
        position: "top-right",
        autoClose: 1500,
        style: {
          minWidth: "250px",
          maxWidth: "400px",
        },
      });

      setTimeout(() => {
        navigate("/signin");
      }, 500);
    } catch (error: any) {
      console.error("Logout failed:", error);
      if (error.code === "ERR_NETWORK") {
        toast.error("Network error. Please check your internet connection.", {
          position: "top-right",
          autoClose: 2000,
        });
      } else {
        toast.error("Logout failed. Please try again.", {
          position: "top-right",
          autoClose: 2000,
        });
      }
      hasLoggedOut.current = false;
    }
  };

  logoutUser();
}, [navigate]);


  return (
    <div className="flex items-center justify-center h-screen">
      <ToastContainer />
      <div className="flex items-center gap-3">
        {/* <svg
          className="animate-spin h-5 w-5 text-gray-700 dark:text-gray-300"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8h8a8 8 0 01-16 0z"
          />
        </svg> */}
        <p className="text-lg text-gray-700 dark:text-gray-300">
          Logging you out, please wait...
        </p>
      </div>
    </div>
  );
};

export default Logout;